module.exports = __webpack_public_path__ + "img/9e4388d.svg";